export const LIBRARY_EVENT_NAMESPACE = 'Personalization Library';
export const LIBRARY_USAGE_EVENTS = {
  BUTTON_CLICK: 'Button Clicked',
  VARIANT_CREATE: 'Variant Created'
};
export const BUTTON_CLICK_ACTIONS = {
  backToPersonalization: 'back_to_personalization',
  variantSelect: 'variant_select',
  createPersonalization: 'create_personalization',
  createPersonalizationWithAi: 'create_personalization_with_ai',
  preview: 'preview'
};
export const VARIANT_CREATE_ACTIONS = {
  createdManually: 'created_manually',
  createdWithAi: 'created_with_ai'
};